import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'

export type ScheduleDeletePayload = {
  id: number
}

export const scheduleDeleteService = async ({ id }: ScheduleDeletePayload) => {
  const { data } = await api.delete<ResponseAPI>(`/agendamento/id/${id}`)

  return data
}
